import { render, staticRenderFns } from "./SettingLabel.vue?vue&type=template&id=5ec5ffa1"
import script from "./SettingLabel.vue?vue&type=script&lang=js"
export * from "./SettingLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports